import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import App from "./App";
import Home from "./components/pages/home/home";
import InternaService from "./components/pages/internaServices/internaService";
import InternaInformation from "./components/pages/internaInformation/internaInformation";
import InternaInformation2 from "./components/pages/internaInformation2/internaInformation2";
import InternaPackages from "./components/pages/internaPackages/internaPackages";
import Legals from "./components/base/legals/legals";
import LandingPage from "./components/base/landingPage/landingPage";
import PromotionPage from "./components/pages/promotionPage/promotionPage";
import CountryAccess from "./components/pages/countryAccess/countryAccess";
import AccessCard from "./components/pages/accesCard/accessCard";
import Loading from "./components/base/loading/loading";
import NotFound from "./components/base/notFound/notFound";

const query = `{
  comonentSeoMetadataCollection {
    items{
   		  path
         pageType
    }
  }
}`;

const AppRouter = () => {
  const [routes, setRoutes] = React.useState(false);

  useEffect(() => {
    window
      .fetch(`https://graphql.contentful.com/content/v1/spaces/5btn2y9mgkqy/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer b3AQUpg-vBOOEAh9q_GsxA5r5Iq170qfW8BnsdAjObE",
        },
        // send the GraphQL query
        body: JSON.stringify({ query }),
      })
      .then((response) => response.json())
      .then(({ data, errors }) => {
        if (errors) {
          console.error("erros", errors);
        }

        let aPaths = [];
        data.comonentSeoMetadataCollection.items.forEach((route) => {
          if (route.path) {
            aPaths.push(route);
          }
        });

        setRoutes(aPaths);
      });
  }, []);

  if (!routes) {
    return <Loading />;
  }

  const getComponentName = (id) => {
    let page = {};

    switch (id) {
      case "home":
        page = <Home />;
        break;

      case "interna-information":
        page = <InternaInformation />;
        break;

      case "interna-information-two":
        page = <InternaInformation2 />;
        break;

      case "interna-packages":
        page = <InternaPackages />;
        break;

      case "interna-services":
        page = <InternaService />;
        break;

      case "landing-page-two":
        page = <LandingPage />;
        break;

      case "promotions-page":
        page = <PromotionPage />;
        break;

      case "access-card-page":
        page = <AccessCard />;
        break;

      case "landing-access":
        page = <CountryAccess />;
        break;

      default:
        return <Loading />;
      // break;
    }

    return page;
  };

  return (
    <Router>
      <Routes>
        <Route path="*" element={<NotFound />} />
        <Route exact path="/legales" element={<Legals />} />
        <Route path="/" element={<App />} />
        {routes.map((route, i) => {
          return (
            <Route
              exact
              path={route.path}
              key={i}
              element={getComponentName(route.pageType)}
            />
          );
        })}
        <Route
          exact
          status={302}
          path="/pa/home-pa"
          element={<Navigate to="/pa/tarjeta-visa-pa" />}
        />
        <Route
          exact 
          path="/pa/"
          element={<Navigate status={302} to="/pa/tarjeta-visa-pa" />}
        />
        <Route
          exact 
          path="/sv/"
          element={<Navigate to="/sv/home-sv" />}
        />
        <Route
          exact 
          path="/hn/"
          element={<Navigate to="/hn/home-hn" />}
        />
        <Route
          exact 
          path="/bo/"
          element={<Navigate to="/bo/home-bo" />}
        />
        <Route
          exact 
          path="/gt/"
          element={<Navigate to="/gt/home-gt" />}
        />
        <Route
          exact 
          path="/py/"
          element={<Navigate to="/py/home-py" />}
        />
      </Routes>
    </Router>
  );
};

export default AppRouter;
